// extracted by mini-css-extract-plugin
export var divider = "_1w-0";
export var dividerText = "_1w-2";
export var dividerVertical = "_1w-1";